const STORAGE_KEY = "afrimed_notification_center"
const MAX_ITEMS = 30

function loadNotifications() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed : []
  } catch (error) {
    return []
  }
}

function persistNotifications(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
  } catch (error) {
    // Ignore storage failures and keep the in-memory state usable.
  }
}

export const state = {
  items: loadNotifications(),
}

export const getters = {
  unreadCount: (state) => state.items.filter((item) => !item.read).length,
  items: (state) => state.items,
}

export const mutations = {
  pushNotification(state, notification) {
    state.items = [notification, ...state.items].slice(0, MAX_ITEMS)
    persistNotifications(state.items)
  },
  clearNotification(state, id) {
    state.items = state.items.filter((item) => item.id !== id)
    persistNotifications(state.items)
  },
  clearAllNotifications(state) {
    state.items = []
    persistNotifications(state.items)
  },
  markAllRead(state) {
    state.items = state.items.map((item) => ({
      ...item,
      read: true,
    }))
    persistNotifications(state.items)
  },
}

export const actions = {
  addNotification({ commit }, notification) {
    commit("pushNotification", notification)
  },
  clearNotification({ commit }, id) {
    commit("clearNotification", id)
  },
  clearAllNotifications({ commit }) {
    commit("clearAllNotifications")
  },
  markAllRead({ commit }) {
    commit("markAllRead")
  },
}
